import Vue from "vue";
import Router from "vue-router";
import LoginForm from "@/components/LoginForm";
import NotFound from "@/components/NotFound";
import TablesList from "@/components/TablesList";
import WaitingRoom from "@/components/WaitingRoom";
import Game from "@/components/Game";
import Rules from "@/components/Rules";
import Privacy from "@/components/Privacy";
import ContactForm from "@/components/ContactForm";
import store from '@/store'

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      meta: { title: 'Briscola Chiamata Online' },
      component: LoginForm
    },
    {
      path: "/tables",
      name: "tables",
      meta: { title: "Sala Tornei" },
      component: TablesList
    },
    {
      path: "/room",
      name: "room",
      meta: { title: "Tavolo" },
      component: WaitingRoom
    },
    {
      path: "/game",
      name: "game",
      meta: { title: "Partita" },
      component: Game
    },
    {
      path: "/rules",
      name: "rules",
      meta: { title: "Regolamento" },
      component: Rules
    },
    {
      path: "/privacy",
      name: "privacy",
      meta: { title: "Privacy" },
      component: Privacy
    },
    {
      path: "/contact-us",
      name: "contactUs",
      meta: { title: "Contatti" },
      component: ContactForm
    },
    {
      path: "/notfound",
      name: "notFound",
      meta: { title: "404 - Pagina non trovata" },
      component: NotFound
    }
  ]
});
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  if (to.name !== 'game' && store.state.game.game.id) {
    next({ path: '/game' })
  } else next()
})
export default router;
